import { useTranslation } from "react-i18next";

export const Home = () => {
  const { t } = useTranslation();

  return (
    <div>
      <h1>{t("home.title")}</h1>
    </div>
  );
};
